import axiosInstance from 'apis/axiosInstance';

import useMatchMutate from 'hooks/useMatchMutate';
import { FC, useState } from 'react';
import InsuranceSwitch from '../InsuranceSwitch/InsuranceSwitch';

export const INSURANCE_PROPERTY = {
  IS_ACTIVE: 'isActive' as const,
  IS_IN_NETWORK: 'isInNetwork' as const,
  IS_OUT_OF_NETWORK: 'isOutOfNetwork' as const,
};

interface InsuranceToggleProps {
  insurance: {
    clinicId: string;
    id: string;
    isActive: boolean;
    name: string;
    isInNetwork: boolean;
    isOutOfNetwork: boolean;
  };
  currentField: (typeof INSURANCE_PROPERTY)[keyof typeof INSURANCE_PROPERTY];
}
const InsuranceToggle: FC<InsuranceToggleProps> = ({
  insurance,
  currentField,
}) => {
  const [isChecked, setIsChecked] = useState(insurance[currentField]);
  const [isLoading, setIsLoading] = useState(false);

  const matchMutate = useMatchMutate();

  const onChange = async () => {
    try {
      setIsLoading(true);
      const payload: any = {
        [currentField]: !isChecked,
      };

      if (currentField === INSURANCE_PROPERTY.IS_ACTIVE && isChecked === true) {
        payload[INSURANCE_PROPERTY.IS_IN_NETWORK] = false;
      }

      await axiosInstance.patch(`/insurances/${insurance.id}`, payload);
      setIsChecked(!isChecked);
      // Revalidate all toggle
      await matchMutate(/\/admin\/insurances\/status/, { revalidate: true });
      await matchMutate(/\/insurances/);
    } catch (error) {}
    setIsLoading(false);
  };

  return (
    <InsuranceSwitch
      isChecked={isChecked}
      isLoading={isLoading}
      onChange={onChange}
    />
  );
};

export default InsuranceToggle;
